<script>
// Logo Genially (isotype) en vecteur, version monochrome : anneau gris + cœur
// noir + « g » blanc (le gris rend visible l'anneau segmenté, sinon noyé dans le
// noir). Couleurs fixes (pas de currentColor) pour rester lisible quel que soit
// le fond (ex. survol coloré du sélecteur de blocs).
export default {
  name: 'GeniallyLogoMark',
};
</script>

<template>
  <svg
    class="geniallylogomark"
    viewBox="0 0 238.18 238.18"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Genially"
  >
    <path d="M223.22,61.37A119,119,0,0,0,119.09,0V119.09Z" fill="#A6A6A6" />
    <path d="M221.14,180.41a119,119,0,0,0,1.08-120.87L119.09,119.09Z" fill="#A6A6A6" />
    <path d="M117,238.13a119,119,0,0,0,105.21-59.5L119.09,119.09Z" fill="#A6A6A6" />
    <path d="M15,176.81a119,119,0,0,0,104.14,61.37V119.09Z" fill="#A6A6A6" />
    <path d="M17,57.77A119,119,0,0,0,16,178.63l103.14-59.54Z" fill="#A6A6A6" />
    <path d="M121.17.05A119,119,0,0,0,16,59.54l103.14,59.55Z" fill="#A6A6A6" />

    <circle fill="#121212" cx="119.09" cy="119.09" r="94.02" />
    <path fill="#FFFFFF" d="M179.3,117.68A11.64,11.64,0,0,0,167.86,127a47.49,47.49,0,1,1-30.94-54.21A11.34,11.34,0,0,0,150.53,68l.5-.85a11.25,11.25,0,0,0-6-16.29,70.87,70.87,0,1,0,45.79,80.59A11.65,11.65,0,0,0,179.3,117.68Z" />
    <path fill="#FFFFFF" d="M138.42,110.61a15.25,15.25,0,1,0,15.24,15.25A15.25,15.25,0,0,0,138.42,110.61Z" />
  </svg>
</template>

<style lang="scss" scoped>
.geniallylogomark {
  display: inline-block;
  height: 1em;
  width: auto;
  vertical-align: middle;
}
</style>
